import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { color } from '../../app/theme';
import { TWD } from '../../app/utils';
import InfoIcon from '../../assets/images/svg/ic-help-circle.svg';
import Tooltip from './Tooltip';

const useStyles = makeStyles(
  () => ({
    root: {
      fontSize: 13,
      lineHeight: '13px',
      color: color.$3,
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    red: {
      color: color.$17,
    },
  }),
  {
    name: 'Quota',
  },
);

/**
 * 配額顯示元件，用於顯示使用量與配額的比較。
 *
 * ## 功能特色
 * - 自動格式化數字顯示（千分位）
 * - 超出配額時自動顯示紅色警告
 * - 支援自訂文字標籤
 * - 支援提示說明
 * - 支援國際化
 *
 * @param {number} [quota=0] 總配額數量
 * @param {number} [used=0] 已使用數量
 * @param {string} [quotaText=''] 配額文字標籤，不提供則使用國際化文字
 * @param {string} [usedText=''] 已使用文字標籤，不提供則使用國際化文字
 * @param {string} [tooltip=''] 提示訊息，若設置會顯示提示圖示
 * @param {string} [className=''] 套用至根元素的額外 CSS 類名
 *
 * @example
 * ```jsx
 * // 基本使用
 * <Quota quota={10000} used={5000} />
 * ```
 *
 * @example
 * ```jsx
 * // 超出配額（會顯示紅色）
 * <Quota quota={1000} used={1200} />
 * ```
 *
 * @example
 * ```jsx
 * // 自訂文字和提示
 * <Quota
 *   quota={50000}
 *   used={30000}
 *   quotaText="總額度"
 *   usedText="已使用"
 *   tooltip="本月配額將於每月1號重置"
 * />
 * ```
 */
const Quota = ({
  usedText = '',
  quotaText = '',
  used = 0,
  quota = 0,
  className = '',
  tooltip = '',
  ...props
}) => {
  const classes = useStyles();

  return (
    <div
      className={classnames(
        classes.root,
        {
          [classes.red]: used >= quota,
        },
        className,
      )}
      {...props}
    >
      <div>
        {quotaText}：{TWD(quota, false).format()}
      </div>
      <div style={{ marginLeft: 8 }}>
        {usedText}：{TWD(used, false).format()}
      </div>
      {tooltip && (
        <Tooltip light title={tooltip}>
          <InfoIcon />
        </Tooltip>
      )}
    </div>
  );
};

export default Quota;
